export const state = {
    isShown: true,
    currentPage: '',
};